export const ACCEPTED_FILENAME_CHARACTERS = /^[a-zA-Z0-9\-_.\s]+$/;
export const FILENAME_MAX_LENGTH = 256;
export const PAGE_SIZE = 30;
